import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';
import LegalNotice from './components/LegalNotice';
import CookiePolicy from './components/CookiePolicy';
import ScrollToTop from './components/ScrollToTop';
import FloatingWhatsAppButton from './components/FloatingWhatsAppButton';
import HomePage from './pages/HomePage';
import DirectoryPage from './pages/DirectoryPage';
import LawyerPage from './pages/LawyerPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PaymentMethodsPage from './pages/PaymentMethodsPage';
import LawyerProfilePage from './pages/LawyerProfilePage';
import LawyerServicesPage from './pages/LawyerServicesPage';
import BackOfficePage from './pages/BackOfficePage';
import ExploreCategoriesPage from './pages/ExploreCategoriesPage';
import ExploreByStatePage from './pages/ExploreByStatePage';
import JoinDirectoryPage from './pages/JoinDirectoryPage';
import DirectoryPlansPage from './pages/DirectoryPlansPage';
import SupportPage from './pages/SupportPage';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />

          <Route path="/explora" element={<DirectoryPage />} />
          <Route path="/explora/categorias" element={<ExploreCategoriesPage />} />
          <Route path="/explora/estado" element={<ExploreByStatePage />} />

          <Route path="/profesionales/unete" element={<JoinDirectoryPage />} />
          <Route path="/profesionales/planes" element={<DirectoryPlansPage />} />
          <Route path="/profesionales/back-offices" element={<BackOfficePage />} />

          <Route path="/quienes-somos" element={<AboutPage />} />
          <Route path="/metodos-de-pago" element={<PaymentMethodsPage />} />
          <Route path="/soporte" element={<SupportPage />} />

          <Route path="/directorio" element={<Navigate to="/explora" replace />} />
          <Route path="/soy-abogado" element={<Navigate to="/profesionales/planes" replace />} />
          <Route path="/servicios-abogados" element={<LawyerServicesPage />} />
          <Route path="/back-office" element={<Navigate to="/profesionales/back-offices" replace />} />
          <Route path="/nosotros" element={<Navigate to="/quienes-somos" replace />} />
          <Route path="/metodos-pago" element={<Navigate to="/metodos-de-pago" replace />} />
          <Route path="/contacto" element={<Navigate to="/soporte" replace />} />

          <Route path="/legacy/soy-abogado" element={<LawyerPage />} />
          <Route path="/legacy/contacto" element={<ContactPage />} />

          <Route path="/abogado/:slug" element={<LawyerProfilePage />} />
          <Route path="/politica-privacidad" element={<PrivacyPolicy />} />
          <Route path="/terminos-condiciones" element={<TermsConditions />} />
          <Route path="/aviso-legal" element={<LegalNotice />} />
          <Route path="/politica-cookies" element={<CookiePolicy />} />
        </Routes>
        <Footer />
        <FloatingWhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
